import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">最新快讯</h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">实时追踪最新吃瓜动态，每条都是新鲜热乎的大瓜</p>
        </div>

        <div className="relative pl-8 before:absolute before:left-[15px] before:top-2 before:bottom-2 before:w-px before:bg-background-200">
          {updateItems.map((item) => (
            <div key={item.id} className="relative pb-6 last:pb-0">
              <span className={`absolute -left-8 top-1 w-3 h-3 rounded-full border-2 ${item.type === 'hot' ? 'bg-primary-500 border-primary-300' : 'bg-accent-500 border-accent-300'}`} />
              <div className="flex items-center gap-3 mb-1 flex-wrap">
                <span className="text-xs font-medium text-foreground-500">{item.date}</span>
                <span className="text-xs font-medium text-foreground-400">{item.time}</span>
                {item.type === 'hot' && (
                  <span className="px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full">热门</span>
                )}
                {item.type === 'new' && (
                  <span className="px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full">新瓜</span>
                )}
              </div>
              <p className="text-sm md:text-base text-foreground-800 leading-relaxed font-medium">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}